export var toSnakeCase = function (s) {
    return s.replace(/([A-Z])/g, function ($1) { return '_' + $1.toLowerCase(); });
};
export var toCamelCase = function (s) {
    return s.replace(/(_[a-z])/g, function ($1) { return $1.slice(1).toUpperCase(); });
};
//# sourceMappingURL=string.js.map